import { LynxService } from "../../../services/lynx.service";
import { Proto } from "../../../pojo/Proto";
import ISODateString = Proto.ISODateString;

export class S25LynxStatusService {
    public static async getStatus() {
        const instance = "qawd"; //TODO dynamically get instance

        const resp = await LynxService.callLynxInstance<Promise<{ sys: { object: LynxStatus.Status[] } }>>(
            instance,
            "get",
            `sys.json?cmd=client_status`,
        );

        return resp?.sys?.object ?? [];
    }

    public static async getHistory() {
        const instance = "qawd"; //TODO dynamically get instance

        const resp = await LynxService.callLynxInstance<Promise<{ sys: { object: LynxStatus.History[] } }>>(
            instance,
            "get",
            `sys.json?cmd=events&is_paginate=1&page_size=4&page=1&sort=lastModDt&order=desc`,
        );

        return resp?.sys?.object ?? [];
    }
}

export namespace LynxStatus {
    export type Status = {
        clientStatusDesc: string;
        level: level;
        clientStatus: number;
    };

    export type level = "INFO";
    export type eventType = "init";

    export type History = {
        eventLevel: level;
        lastModDtDisp: string;
        eventName: string;
        id: number;
        eventType: eventType;
        lastModDt: ISODateString;
    };
}
